
















































import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import SidebarSwitcher from '@/components/organisms/v2/SidebarSwitcher.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import UnitInformationAligned from '@/components/organisms/v3/UnitInformationAligned.vue'
import StudentBottomPanel from '@/components/organisms/v3/StudentBottomPanel.vue'
import ClassModeMethods from '@/mixins/utils/ClassModeMethods'
import PositionListUnit from '@/mixins/positionListUnit/PositionListUnit'
import InputWithSearch from '@/components/molecules/InputWithSearch.vue'
import AlignedWebApi from '@/mixins/drillsv3/AlignedWebApi'
import DrillWebApi from '@/mixins/drillsv3/WebApi'

const GRADE_OPTIONS = [
  { text: '中1', value: '7' },
  { text: '中2', value: '8' },
  { text: '中3', value: '9' },
]

export type Unit = {
  curriculumSUnitId: number
  name: string
  isCompleted: boolean
}

enum LearningStatus {
  ALL,
  NOT_LEARNED,
  LEARNED,
}

@Component({
  components: {
    SidebarSwitcher,
    ButtonBase,
    SelectBase,
    UnitInformationAligned,
    StudentBottomPanel,
    InputWithSearch,
  },
})
export default class CurriculumLUnitsAligned extends Mixins(
  ClassModeMethods,
  PositionListUnit,
  AlignedWebApi,
  DrillWebApi
) {
  private statusSelectedData = LearningStatus.ALL
  private inputCurriculumSUnitName = ''
  private subjectId = this.$route.query.subjectId
  private subjectCode = this.$route.query.subjectCode
  private gradeIdSelected = Vue.prototype.$cookies.get('dataGdls').gradeIdSelectedAligned || GRADE_OPTIONS[0].value
  private isLUnit = this.$route.path.includes('l-unit')

  private subjectNames = {
    su: '算数/数学',
    ei: '英語',
    ko: '国語',
    sh: '社会',
    ri: '理科',
  }
  private gradeOptionDatas = GRADE_OPTIONS

  private statusOptionDatas = [
    { text: 'すべて', value: LearningStatus.ALL },
    { text: '未学習', value: LearningStatus.NOT_LEARNED },
    { text: '学習済み', value: LearningStatus.LEARNED },
  ]

  private unitData: Unit[] = []
  private unitDataDisplay: Unit[] = []

  private async handleUnitSelection(unitId: number) {
    this.setScrollPosition(this.$route.path + this.gradeIdSelected)
    if (this.isLUnit) {
      window.location.href = `/student/aligned/s-units?subjectId=${this.subjectId}&lUnitId=${unitId}&subjectCode=${this.subjectCode}`
    } else {
      try {
        const studyLogicType = 'JK'
        const classMode = 'JK'
        const classCategoryCode = 'EN'
        Vue.prototype.$loading.start()
        const drill = await this.startDrillApi(studyLogicType, classMode, classCategoryCode, {
          curriculumSUnitId: unitId,
        })
        this.$router.push({
          path: '/student/v3/drillMath',
          query: {
            resultDrillId: String(drill.resultDrillId),
            page: String(drill.currentPage) || '1',
            lUnitId: this.$route.query.lUnitId,
            subjectCode: this.subjectCode,
            subjectId: this.subjectId,
            type: 'aligned',
          },
        })
      } catch (e) {
        const error: any = e
        alert(error?.response?.data?.message || error?.message)
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
  }

  private async mounted(): Promise<void> {
    window.scrollTo(0, 0)
    Vue.prototype.$loading.start()
    await this.loadDatas()
    this.scrollToPrePosition(this.$route.path + this.gradeIdSelected)
    Vue.prototype.$loading.complete()
  }

  private async loadDatas(): Promise<void> {
    if (this.isLUnit) {
      const data = await this.getCurriculumMUnit({
        subject_id: this.subjectId as string,
        grade_id: this.gradeIdSelected,
      })
      this.unitData = data.curriculumLUnits
      this.unitDataDisplay = data.curriculumMUnits
    } else {
      const lUnitId = this.$route.query.lUnitId
      const data = await this.getCurriculumSUnit({
        curriculum_m_unit_id: lUnitId as string,
        study_logic_type: 'JK',
      })
      this.unitData = data.curriculumSUnits
      this.unitDataDisplay = data.curriculumSUnits
    }
  }

  private get backUrl() {
    if (this.isLUnit) {
      return '/student/aligned/subjects'
    } else {
      return `/student/aligned/l-units?subjectId=${this.subjectId}&subjectCode=${this.subjectCode}`
    }
  }

  private async changeConditions(): Promise<void> {
    Vue.prototype.$loading.start()
    await this.loadDatas()
    Vue.prototype.$loading.complete()
  }

  private handleSearch(): void {
    this.unitDataDisplay = this.unitData.filter((unit: Unit) => {
      return unit.name.includes(this.inputCurriculumSUnitName)
    })
  }

  @Watch('gradeIdSelected')
  private async gradeSelectedCodeChange(newValue: string, oldValue: string): Promise<void> {
    this.inputCurriculumSUnitName = ''
    const cookie = Vue.prototype.$cookies.get('dataGdls')
    cookie['gradeIdSelectedAligned'] = newValue
    await Vue.prototype.$cookies.set('dataGdls', cookie, Function(`return (${process.env.VUE_APP_COOKIE_EXPIRE})`)())
    // 初回は除く
    if (oldValue) await this.changeConditions()
  }

  @Watch('statusSelectedData')
  private async statusSelectedDataChange(): Promise<void> {
    this.inputCurriculumSUnitName = ''
    const status = Number(this.statusSelectedData)
    if (status === LearningStatus.ALL) {
      this.unitDataDisplay = this.unitData
    } else if (status === LearningStatus.NOT_LEARNED) {
      this.unitDataDisplay = this.unitData.filter((unit: Unit) => !unit.isCompleted)
    } else if (status === LearningStatus.LEARNED) {
      this.unitDataDisplay = this.unitData.filter((unit: Unit) => unit.isCompleted)
    }
  }
}
